<app-payment-status></app-payment-status>

<app-home-board *ngIf="boardCards && !loading; else loader" [boardCards]="boardCards"
  [compact]="(platformService.isSmall$ | async)">
</app-home-board>

<ng-template #loader>
  <app-loader class="margin"></app-loader>
</ng-template>